/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { PromptConfigurationsControllerRemoveMutationResponse, PromptConfigurationsControllerRemovePathParams, PromptConfigurationsControllerRemove401, PromptConfigurationsControllerRemove403, PromptConfigurationsControllerRemove404 } from "../../models/promptConfigurationsController/PromptConfigurationsControllerRemove";

function getPromptConfigurationsControllerRemoveUrl(id: PromptConfigurationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/prompt-configurations/${id}` as const }  
  return res
}

/**
 * @summary Delete a prompt configuration (soft delete)
 * {@link /api/v1/prompt-configurations/:id}
 */
export async function promptConfigurationsControllerRemove(id: PromptConfigurationsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<PromptConfigurationsControllerRemoveMutationResponse, ResponseErrorConfig<PromptConfigurationsControllerRemove401 | PromptConfigurationsControllerRemove403 | PromptConfigurationsControllerRemove404>, unknown>({ method : "DELETE", url : getPromptConfigurationsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}